import * as genesis from "./genesis.js";
import * as plugins from "./plugins.js";
import * as custom from "./custom-scripts.js";
import * as menus from "./responsive-menus.js";

jQuery(window).on("load", function () {
  plugins.init();
  custom.init();
});

jQuery(document).ready(function () {
  menus.init();
  genesis.init();
});
